import { AssetsWorkspace } from "../components/snowflakes/assets/AssetsWorkspace";
import type { AssetTreeSearch } from "../lib/assetTreeSearch";

export function AssetTreeScreen({
  routeSearch,
  onRouteSearchChange,
}: {
  routeSearch?: AssetTreeSearch;
  onRouteSearchChange?: (update: Partial<AssetTreeSearch>) => void;
}) {
  return (
    <AssetsWorkspace
      onRouteSearchChange={onRouteSearchChange}
      routeSearch={routeSearch}
    />
  );
}
